/**
 * Error state display for the infrastructure import modal.
 *
 * Extracted from ImportModal.tsx (Sub-PR 6.4).
 */

import { useTranslation } from 'react-i18next'
import { AlertCircle } from 'lucide-react'

interface ErrorDisplayProps {
  error: string
  onRetry: () => void
  onClose: () => void
}

export function ErrorDisplay({ error, onRetry, onClose }: ErrorDisplayProps): React.ReactElement {
  const { t } = useTranslation('cases')

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-950/50">
        <AlertCircle className="h-8 w-8 text-red-600 dark:text-red-400" />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-slate-900 dark:text-white">
        {t('infrastructure.import.importFailed')}
      </h3>
      <p className="mt-2 text-center text-slate-600 dark:text-slate-400">{error}</p>
      <div className="mt-6 flex gap-3">
        <button
          onClick={onClose}
          className="rounded-lg px-4 py-2 text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800"
        >
          {t('actions.cancel')}
        </button>
        <button
          onClick={onRetry}
          className="rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
        >
          {t('actions.tryAgain')}
        </button>
      </div>
    </div>
  )
}
